import * as z from "zod";

export const wsStatuses = ["disconnected", "connecting", "connected"] as const;

export const ZWsStatus = z.enum(wsStatuses);

export type WsStatus = (typeof wsStatuses)[number];

export const serverEventMessageTypes = ["delivery_status", "order_delivered"] as const;

export type ServerEventMessageType = (typeof serverEventMessageTypes)[number];

export type ServerEventMessage = {
   type: ServerEventMessageType;
};

export type ServerEventListener = (message: ServerEventMessage) => void;

export type OrderDeliveredMessage = {
   type: "order_delivered";
   TINEReference: string;
   messageId: string;
   orderNumber: string;
};

export const ZOrderDeliveredMessage: z.ZodType<OrderDeliveredMessage> = z.object({
   type: z.literal("order_delivered"),
   TINEReference: z.string(),
   messageId: z.string(),
   orderNumber: z.string()
});
